import { render, staticRenderFns } from "./SessionDestroy.vue?vue&type=template&id=45da3eae&scoped=true&"
import script from "./SessionDestroy.vue?vue&type=script&lang=js&"
export * from "./SessionDestroy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45da3eae",
  null
  
)

export default component.exports